var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.516 7.5c-4.606 0-8.747-3-15.179-3-2.934 0-5.466.608-7.568 1.422a4.504 4.504 0 0 0 .201-1.943A4.512 4.512 0 0 0 4.8.009a4.5 4.5 0 0 0-2.55 8.387V46.5a1.5 1.5 0 0 0 1.5 1.5h1.5a1.5 1.5 0 0 0 1.5-1.5v-7.823C10.3 37.057 13.43 36 18.734 36c4.606 0 8.747 3 15.179 3 5.482 0 9.56-2.12 12.051-3.748A4.496 4.496 0 0 0 48 31.486V8.994c0-3.23-3.306-5.416-6.272-4.136C38.362 6.31 34.84 7.5 31.516 7.5zm11.984 24c-2.042 1.445-5.702 3-9.587 3-5.62 0-9.563-3-15.18-3-4.064 0-9.035.882-11.983 2.25V12c2.042-1.445 5.702-3 9.587-3 5.62 0 9.563 3 15.18 3 4.056 0 9.03-1.628 11.983-3v22.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.0aa0b581014e3a34b2feeba91f0f56f2.svg";
export { ForwardRef as ReactComponent };